import $ from "jquery";

export default class Checkout {
    constructor() {
        this.paymentInfoLabel = document.querySelector(".jsInfoPaymentLabel");
        this.shippingInfoLabel = document.querySelector(".jsInfoShippingLabel");
        this.totalReviewPrice = document.querySelector(".jsTotalReviewPrice");
        this.checkoutPriceTotal = document.querySelector(
            ".jsCheckoutPriceTotal"
        );
        this.checkoutMain = document.querySelector(
            ".woocommerce-checkout .jsMain"
        );

        if (
            this.checkoutMain &&
            this.paymentInfoLabel &&
            this.shippingInfoLabel &&
            this.totalReviewPrice
        ) {
            this.paymentLabels = Array.from(
                this.checkoutMain.querySelectorAll(".jsPaymentMethodLabel")
            );
            this.paymentRadios = Array.from(
                this.checkoutMain.querySelectorAll(".jsPaymentMethodInput")
            );

            this.shippingLabels = Array.from(
                this.checkoutMain.querySelectorAll(".jsShippingMethodLabel")
            );
            this.shippingRadios = Array.from(
                this.checkoutMain.querySelectorAll(".jsShippingMethodInput")
            );

            this.billingCountry = document.getElementById("billing_country");
            this.shippingCountry = document.getElementById("shipping_country");
            this.diffrentAddress = document.getElementById(
                "ship-to-different-address-checkbox"
            );

            this.events();
        }
    }

    events() {
        window.addEventListener(
            "DOMContentLoaded",
            (e) => {
                const currentPaymentMethod = this.checkForPaymentRadioOnLoad();
                this.getSelectedPaymentMethod(currentPaymentMethod);

                const currentShippingMethod =
                    this.checkForShippingRadioOnLoad();
                this.getSelectedShippingMethod(currentShippingMethod);

                if (this.billingCountry) {
                    this.fvCheckbox();
                }
            },
            {
                once: true,
            }
        );

        if (this.billingCountry) {
            $(this.billingCountry).on("select2:select", (e) => {
                this.fvCheckbox();
            });
            $(this.shippingCountry).on("select2:select", (e) => {
                this.fvCheckbox();
            });
        }

        if (this.diffrentAddress) {
            this.diffrentAddress.addEventListener("change", (e) => {
                this.fvCheckbox();
            });
        }

        this.checkoutMain.addEventListener("click", (e) => {
            this.getClickedPaymenMethodLabel(e);
            this.getClickedShippingMethodLabel(e);
        });

        $(document).ajaxComplete(this.updateTotalPrice.bind(this));
    }

    checkForPaymentRadioOnLoad(e) {
        let selectedPaymentMethod;

        if (this.paymentRadios.length && this.paymentRadios.length > 1) {
            selectedPaymentMethod = this.paymentRadios.filter(
                (radio) => radio.checked
            )[0];
        } else if (
            this.paymentRadios.length &&
            this.paymentRadios.length === 1
        ) {
            selectedPaymentMethod = this.paymentRadios[0];
        } else {
            selectedPaymentMethod = null;
        }

        return selectedPaymentMethod;
    }

    getSelectedPaymentMethod(radio) {
        if (radio === null) return;

        const paymentMethodId = radio.id;
        const paymentMethodLabel = this.paymentLabels.filter(
            (label) => label.getAttribute("for") === paymentMethodId
        )[0];

        this.setInfoPaymentMethod(paymentMethodLabel);
    }

    getClickedPaymenMethodLabel(e) {
        const clickedLabel = e.target.closest(".jsPaymentMethodLabel");

        if (
            clickedLabel &&
            clickedLabel.classList.contains("jsPaymentMethodLabel")
        ) {
            this.setInfoPaymentMethod(clickedLabel);
        }
    }

    setInfoPaymentMethod(label) {
        const paymentMethodHTML = label.innerHTML;

        this.paymentInfoLabel.innerHTML = paymentMethodHTML;
    }

    checkForShippingRadioOnLoad(e) {
        let selectedShippingMethod;

        if (this.shippingRadios.length && this.shippingRadios.length > 1) {
            selectedShippingMethod = this.shippingRadios.filter(
                (radio) => radio.checked
            )[0];
        } else if (
            this.shippingRadios.length &&
            this.shippingRadios.length === 1
        ) {
            selectedShippingMethod = this.shippingRadios[0];
        } else {
            selectedShippingMethod = null;
        }

        return selectedShippingMethod;
    }

    getSelectedShippingMethod(radio) {
        if (radio === null) return;

        const shippingMethodId = radio.id;
        const shippingMethodLabel = this.shippingLabels.filter(
            (label) => label.getAttribute("for") === shippingMethodId
        )[0];

        this.setInfoShippingMethod(shippingMethodLabel);
    }

    getClickedShippingMethodLabel(e) {
        const clickedLabel = e.target.closest(".jsShippingMethodLabel");

        if (
            clickedLabel &&
            clickedLabel.classList.contains("jsShippingMethodLabel")
        ) {
            this.setInfoShippingMethod(clickedLabel);
        }
    }

    setInfoShippingMethod(label) {
        const shippingMethodHTML = label.innerHTML;

        this.shippingInfoLabel.innerHTML = shippingMethodHTML;
    }

    updateTotalPrice() {
        this.checkoutPriceTotal = this.checkoutMain.querySelector(
            ".jsCheckoutPriceTotal"
        );

        this.totalReviewPrice.innerHTML = this.checkoutPriceTotal.innerHTML;
    }

    fvCheckbox() {
        const invoiceOption = document.querySelector(
            "label[for=fv_checkbox_fv]"
        );

        if (this.billingCountry && invoiceOption) {
            if (
                (this.billingCountry.value === "GB" &&
                    this.diffrentAddress.checked === false) ||
                (this.shippingCountry.value === "GB" &&
                    this.diffrentAddress.checked === true) ||
                (this.billingCountry.value === "VG" &&
                    this.diffrentAddress.checked === false) ||
                (this.shippingCountry.value === "VG" &&
                    this.diffrentAddress.checked === true)
            ) {
                invoiceOption.style.display = "none";
                invoiceOption.checked = false;
                document.getElementById("vat_number_field").style.display =
                    "none";
                document.getElementById("billing_company_field").style.display =
                    "none";
                document.getElementById("fv_checkbox_receipt").checked = true;
            } else {
                invoiceOption.style.display = "block";
            }
        }
    }
}
